import React, { useState, useEffect } from "react";
import { spinnerService } from "@chevtek/react-spinners";
import { connect } from "react-redux";
import imgPlaceholder from "../../assets/img/logo-placeholder.jpg";
import * as _ from "lodash";
import moment from "moment";
import ZoomInIcon from "@material-ui/icons/ZoomIn";
import ZoomOutIcon from "@material-ui/icons/ZoomOut";
import { toast, Zoom, Flip } from "react-toastify";
import gql from "graphql-tag";
import {
  mainDashboardQuery,
  getVehicleDefects,
  archivedDefects,
  myGetCustomerExtended
} from "../../data/customQueries";
import { getCustomerTeam } from "../../graphql/queries";
import createAbsoluteGrid from "react-absolute-grid";
import VehicleCard from "./vehicleCard";
import ReactDOM from "react-dom";
import * as actionTypes from "../../redux/actions";
import { Row, Col, Button, Badge } from "reactstrap";
import IconButton from "@material-ui/core/IconButton";
import AppsIcon from "@material-ui/icons/Apps";
import NewCustomerVehicles from "./NewCustomerVehicles";

let vehicleDispData = [];
let arcDefectsDispData = [];
let actDefectsDispData = [];

const VehilcleList = ({
  client,
  user,
  vehicleGrid,
  storeVehicleGrid,
  history
}) => {
  const [newView, setNewView] = useState(false);

  const getData = async () => {
    vehicleDispData = [];
    arcDefectsDispData = [];
    actDefectsDispData = [];
    let today = new Date();
    let dueDate = moment(today).add(15, "days");
    spinnerService.show("mySpinner");
    let custUsername = user.username;
    let userType = null;
    if (
      user !== null &&
      user !== "notFound" &&
      user.signInUserSession.idToken.payload["cognito:groups"] !== undefined
    ) {
      userType = user.signInUserSession.idToken.payload["cognito:groups"][0];
    }
    if ((userType === "Dispatchers") | (userType === "Technicians")) {
      let custTeam = (await client.query({
        query: gql(getCustomerTeam),
        fetchPolicy: `network-only`,
        variables: { id: user.username }
      })).data.getCustomerTeam;
      custUsername = custTeam.customer.id;
    }

    try {
      let res = null;

      res = (await client.query({
        query: gql(mainDashboardQuery),
        fetchPolicy: `no-cache`,
        variables: { id: custUsername, dueDate: dueDate, limit: 1000 }
      })).data.getCustomer;
      // const returnData = await client.query({
      //   // query: gql(getCustomer),
      //   query: gql(myGetCustomerExtended),
      //   fetchPolicy: `network-only`,
      //   variables: {
      //     id: custUsername
      //   }
      // });
      const data = res.defectsByStatus;
      if (data.items !== null && data.items.length !== 0) {
        data.items.map((dt, i) => {
          if (["REVOKED", "REPAIRED"].includes(dt.status)) {
            let arcDefectsObj = {
              key: i,
              id: dt.id,
              reportedDateTime:
                dt.reportedDateTime !== null
                  ? moment(dt.reportedDateTime)
                      .toISOString()
                      .split("T")[0]
                  : "",
              customerInfo:
                dt.vehicle !== null
                  ? res.vehicles.items.filter(v => v.id === dt.vehicle.id)
                  : " ",
              defectType: dt.defectType,
              defectDesc: dt.defectDesc,
              sourceType: dt.sourceType,
              status: dt.status,
              repairedDateTime:
                dt.repairedDateTime !== null
                  ? moment(dt.repairedDateTime)
                      .toISOString()
                      .split("T")[0]
                  : "",
              assignedByUserId: null,
              assignedToUserId: null
            };
            arcDefectsDispData.push(arcDefectsObj);
          } else {
            let actDefectsObj = {
              key: i,
              id: dt.id,
              reportedDateTime:
                dt.reportedDateTime !== null
                  ? moment(dt.reportedDateTime)
                      .toISOString()
                      .split("T")[0]
                  : "",
              customerInfo:
                dt.vehicle !== null
                  ? res.vehicles.items.filter(v => v.id === dt.vehicle.id)
                  : " ",
              defectType: dt.defectType,
              defectDesc: dt.defectDesc,
              sourceType: dt.sourceType,
              status: dt.status,
              repairedDateTime:
                dt.repairedDateTime !== null
                  ? moment(dt.repairedDateTime)
                      .toISOString()
                      .split("T")[0]
                  : "",
              assignedByUserId: null,
              assignedToUserId: null
            };
            actDefectsDispData.push(actDefectsObj);
          }
        });
      }

      if (res.vehicles.items !== null) {
        let index = 0;
        res.vehicles.items.forEach(item => {
          index++;
          let vehDefectCount = 0;
          let dispObj = {
            key: index,
            redTag: false,
            name: item.customerVehicleId,
            VIN: item.VIN,
            id: item.id,
            sort: 0,
            make: item.make,
            model: item.model,
            mainPic: item.mainPic,
            history: history
          };
          if (item.vehicleType)
            dispObj.vehCategory = item.vehicleType.vehicleCategory;

          if (
            !(
              item.nextInspectionDue === undefined ||
              item.nextInspectionDue === null
            )
          ) {
            if (item.nextInspectionDue.length > 0) {
              dispObj.nextInspectionDue = item.nextInspectionDue[0].nextDueDate;
            }
          }
          res.defectsByStatus.items.map(defect => {
            if (defect.vehicle !== null) {
              if (defect.vehicle.id === item.id) {
                if (defect.redTag === true) dispObj.redTag = true;
                //if (defect.sourceType === "DVIR")
                vehDefectCount++;
                dispObj.defectStatus = defect.status;
              }
            }
          });
          dispObj.hasDefects = false;
          dispObj.defectCount = vehDefectCount;
          if (vehDefectCount > 0) {
            dispObj.hasDefects = true;
          }
          if (dispObj.hasDefects) vehicleDispData.push(dispObj);
        });
      }
      arcDefectsDispData = arcDefectsDispData.sort(
        (a, b) => moment(b.reportedDateTime) - moment(a.reportedDateTime)
      );
      actDefectsDispData = actDefectsDispData.sort(
        (a, b) => moment(b.reportedDateTime) - moment(a.reportedDateTime)
      );
      let sortCounter = 0;
      vehicleDispData.sort((a, b) => {
        if (a.vehCategory > b.vehCategory) {
          sortCounter++;
          a.sort = sortCounter;
          return 1;
        }
        b.sort = sortCounter;
        return -1;
      });
      setNewView(true);
      storeVehicleGrid(vehicleDispData);
      if (vehicleDispData.length <= 10) zoom = 2.0;
      else if (vehicleDispData.length > 10 && vehicleDispData.length <= 20)
        zoom = 1.6;
      renderGrid();
    } catch (error) {}
    spinnerService.hide("mySpinner");
  };
  const AbsoluteGrid = createAbsoluteGrid(VehicleCard);
  let renderGrid = function() {
    if (vehicleDispData.length <= 0) vehicleDispData = vehicleGrid;
    let gridInput = {
      data: vehicleDispData,
      history: history
    };
    ReactDOM.render(
      <AbsoluteGrid
        items={vehicleDispData}
        onMove={onMoveDebounced}
        dragEnabled={true}
        zoom={zoom}
        responsive={true}
        verticalMargin={20}
        itemWidth={80}
        itemHeight={100}
        animation="transform 300ms ease"
      />,
      document.getElementById("grid")
    );
  };
  var onMove = function(source, target) {
    source = _.find(vehicleDispData, { key: parseInt(source, 10) });
    target = _.find(vehicleDispData, { key: parseInt(target, 10) });

    const targetSort = target.sort;

    //CAREFUL, For maximum performance we must maintain the array's order, but change sort
    vehicleDispData = vehicleDispData.map(function(item) {
      //Decrement sorts between positions when target is greater
      if (item.key === source.key) {
        return {
          ...item,
          sort: targetSort
        };
      } else if (
        target.sort > source.sort &&
        (item.sort <= target.sort && item.sort > source.sort)
      ) {
        return {
          ...item,
          sort: item.sort - 1
        };
        //Increment sorts between positions when source is greater
      } else if (item.sort >= target.sort && item.sort < source.sort) {
        return {
          ...item,
          sort: item.sort + 1
        };
      }
      return item;
    });
    //Perf.start();

    renderGrid();

    //Perf.stop();
    //Perf.printWasted();
  };
  var onMoveDebounced = _.debounce(onMove, 40);
  let zoom = 1.6;
  var renderDebounced = _.debounce(renderGrid, 150);

  //Update the zoom value
  var onZoom = function(event) {
    zoom = parseFloat(event.target.value);
    renderDebounced();
  };
  var onFilter = function(event) {
    var search = new RegExp(event.target.value, "i");
    vehicleDispData = vehicleDispData.map(function(item) {
      const isMatched = !item.name.match(search);
      if (!item.filtered || isMatched !== item.filtered) {
        return {
          ...item,
          filtered: isMatched
        };
      }
      return item;
    });
    renderGrid();
  };
  useEffect(() => {
    getData();
  }, []);
  return (
    <div>
      {!newView ? (
        <Row style={{ marginTop: 10 }}>
          {/* {<Col sm={12}>
            <ZoomOutIcon></ZoomOutIcon>
            <input
              onChange={onZoom}
              type="range"
              min="1.6"
              max="3.0"
              step="0.2"
              defaultValue={zoom}
            />
            <ZoomInIcon></ZoomInIcon>
             <div style={{ float: "right" }}>
              <IconButton aria-label="delete">
                <AppsIcon />
              </IconButton>
            </div>
            <div id="grid" style={{ marginTop: 15 }}></div>
          </Col>} */}
          <NewCustomerVehicles
            archiveDefects={arcDefectsDispData}
            activeDefects={actDefectsDispData}
            userGroup={
              user.signInUserSession.idToken.payload["cognito:groups"][0]
            }
          />
        </Row>
      ) : (
        <NewCustomerVehicles
          archiveDefects={arcDefectsDispData}
          activeDefects={actDefectsDispData}
          userGroup={
            user.signInUserSession.idToken.payload["cognito:groups"][0]
          }
        />
      )}
    </div>
  );
};

const mapStateToProps = state => {
  return {
    user: state.config.user,
    loading: state.config.loading,
    client: state.config.client,
    profile: state.config.profile,
    vehicleGrid: state.vehicles.vehicleGrid
  };
};
const mapDispatchToProps = dispatch => {
  return {
    storeVehicleGrid: data => dispatch(actionTypes.storeVehicleGrid(data))
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(VehilcleList);

// export default VehilcleList;



// WEBPACK FOOTER //
// ./src/views/Defects/customerVehicles.jsx